<ion-row class="ion-no-padding">
  <ion-col size="12" class="ion-text-center ion-no-padding-bottom">
    <ion-label color="danger" class="ion-text-bold ion-text-wrap">
      <sup>{{ 'COMMON.NO_INTERNET_CONNECTION' | translate }}</sup>
    </ion-label>
  </ion-col>
</ion-row>
